/* istanbul ignore file */

import getCRUDHooks from '../../utils/services/getCRUDHooks';
import { clientApi } from '../../configuration';

const { useUpdate: useUpdateQuizSessionQuestionsAnswers } = getCRUDHooks({
  entityName: 'quizSessionQuestions',
  update: (values: Array<number>, { quizSessionQuestionId }: { quizSessionQuestionId: string }) => {
    clientApi
      .getOCClient()
      .helpers.assessment.quizSessionQuestions.updateAnswers(quizSessionQuestionId, values);
  },
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useUpdateQuizSessionQuestionsAnswers,
};
